<template>
  <div class="editRoleManagement">
    <div class="filters">
      <el-form :inline="true">
        <!-- 权限说明的折叠板 -->
        <el-collapse v-model="collapse" prop="collapse"  class="collapse"> 
          <el-collapse-item :title="$t('lang.lab_privilegeDescription')">
            <div><span class="quote">{{$t('lang.lab_code')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionEncoding')}}</div>
            <div><span class="quote">{{$t('lang.lab_codeName')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionDisplayName')}}</div>
            <div><span class="quote">{{$t('lang.lab_cellRights')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_allDistricts')}}</span>{{$t('lang.lab_permissUsedCommunityLocated')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_someDistricts')}}</span>{{$t('lang.lab_onlyAuthorizedUsePermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_dividedInto')}}<span class="classical">{{$t('lang.lab_operationAuthority')}}</span>{{$t('lang.lab_and')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_onlyDevelopersPermission')}}{{$t('lang.lab_comma')}}
                 <span class="classical">{{$t('lang.lab_AdministratorRights')}}</span>{{$t('lang.lab_permissionOrdinaryAdministrators')}}{{$t('lang.lab_period')}}
                 <span class="classical">{{$t('lang.lab_developerPermissions')}}</span>{{$t('lang.lab_contain')}}<span class="classical">{{$t('lang.lab_AdministratorRights')}}</span></div>
            <div><span class="quote">{{$t('lang.lab_category')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_permissionsAre')}}<span class="classical">{{$t('lang.lab_radioSelectionType')}}</span>{{$t('lang.lab_suchAsGender')}}{{$t('lang.lab_asWelllAs')}}
                 <span class="classical">{{$t('lang.lab_multipleSelectionType')}}</span>{{$t('lang.lab_suchAsIndividualPermissions')}}</div>
            <div><span class="quote">{{$t('lang.lab_status')}}</span>{{$t('lang.lab_colon')}}{{$t('lang.lab_whetherAvailable')}}</div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
      <el-card>
        <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_returnRoleManagementList')}}</el-button>
        </div>
          <el-form-item :label="$t('lang.lab_roleManagementName')" prop="Name">
            <el-input v-model="ruleForm.Name" maxlength="50" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_roleManagementName')" class="input-width"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_roleManagementFlag')" prop="Flag">
            <el-select v-model="ruleForm.Flag" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_roleManagementFlag')">
              <el-option
                v-for="(item, index) in flagList"
                :key="index"
                :value="item.id"
                :label="item.name"></el-option>
            </el-select>
          </el-form-item>
      </el-card>
      <el-card class="job">
        <el-collapse v-model="jobActiveNames">
          <el-collapse-item
            :label="$t('lang.lab_roleManagementJob')"
            :title="$t('lang.lab_roleManagementJob')"
          >
            <div>
              <el-checkbox
                v-model="item.checkFlag"
                v-for="item in jobList"
                :label="item.JobManagerId"
                :key="item.JobManagerId"
              >{{item.Name}}</el-checkbox>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <el-card class="authority">
        <el-collapse v-model="authorityActiveNames">
          <el-collapse-item
            :label="$t('lang.lab_roleManagementAuthority')"
            :title="$t('lang.lab_roleManagementAuthority')"
          >
            <div>
              <el-checkbox
                v-model="item.checkFlag"
                v-for="item in authorityList"
                :label="item.AuthorityManagerId"
                :key="item.AuthorityManagerId"
              >{{item.Name}}</el-checkbox>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <el-card class="munu">
        <div class="subtitle">
          <span>{{$t('lang.lab_roleManagementMunu')}}</span>
        </div>
        <el-collapse v-model="munuActiveNames">
          <el-collapse-item
            :label="item.munuManagerName"
            :prop="item.munuManagerName"
            class="check-group"
            v-for="(item, index) in munuList"
            :key="index"
            :title="item.munuManagerName"
            :name="index"
          >
            <div>
              <el-checkbox
                v-model="subitem.checkFlag"
                v-for="(subitem, i) in item.munuManagerAdminList"
                :key="i"
              >{{subitem.munuManagerAdminName}}</el-checkbox>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-button class="btn-first martop" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-card>
    </el-form>
  </div>
</template>

<script>
/**
 *@ClassName:editRoleManagement
 *@Description:角色管理-新建/编辑页面
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-07
 */
export default {
  data() {
    return {
      rules: {
        Name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_roleManagementName'), trigger: 'blur' }],
        Flag: [{ required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_roleManagementFlag'), trigger: 'change' }],
      },
      disabledArr: {
        ruleFormDisabled: true,
        munuDisabled: true,
        authorityDisabled: true,
        jobDisabled: true,
      }, // 保存的集合
      disabledArrSave: {
        ruleFormDisabled: true,
        munuDisabled: true,
        authorityDisabled: true,
        jobDisabled: true,
      }, // 保存的集合Save
      disabledSaveData: '', // 保存数组存储json字符串
      isDisabled: true, // 保存的可点击
      isFlag: false, // 编辑:true 新增：false
      saveData: '', // 存储json字符串
      munuSaveData: '', // 管理菜单存储json字符串
      jobSaveData: '', // 管理职务存储json字符串
      authoritySaveData: '', // 管理职责存储json字符串
      munuList: [], // 所有菜单
      jobList: [], // 所有职务
      authorityList: [], // 所有职责
      munuActiveNames: [], // 菜单的折叠
      jobActiveNames: [], // 职务的折叠
      authorityActiveNames: [], // 职责的折叠
      collapse: [], // 权限说明的折叠
      ruleForm: {
        Name: '',
        Flag: 1,
      },
      flagList: this.$i18n.t('lang.EditRoleManagement_flagList'), // 是否启用
    }
  },
  // #8449 add
  destroyed() {
    window.localStorage.setItem('roleManagementForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('roleManagementSaveData', this.saveData)
    window.localStorage.setItem('roleManagement_munuList', JSON.stringify(this.munuList))
    window.localStorage.setItem('roleManagement_munuSaveData', this.munuSaveData)
    window.localStorage.setItem('roleManagement_jobList', JSON.stringify(this.jobList))
    window.localStorage.setItem('roleManagement_jobSaveData', this.jobSaveData)
    window.localStorage.setItem('roleManagement_authorityList', JSON.stringify(this.authorityList))
    window.localStorage.setItem('roleManagement_authoritySaveData', this.authoritySaveData)
  },
  created() {
    // 这是用来保存disabled们初始数据
    this.disabledSaveData = JSON.stringify(this.disabledArrSave)
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
    this.id = this.$route.query.id
    // #8449 add
    if (window.localStorage.getItem('roleManagementForm')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('roleManagementForm'))
      if (window.localStorage.getItem('roleManagementSaveData')) {
        this.saveData = window.localStorage.getItem('roleManagementSaveData')
      }
      if (window.localStorage.getItem('roleManagement_munuList')) {
        this.munuList = JSON.parse(window.localStorage.getItem('roleManagement_munuList'))
     } 
     if (window.localStorage.getItem('roleManagement_munuSaveData')) {
      this.munuSaveData = window.localStorage.getItem('roleManagement_munuSaveData')
     }
      if (window.localStorage.getItem('roleManagement_authorityList')) {
        this.authorityList = JSON.parse(window.localStorage.getItem('roleManagement_authorityList'))
      }
      if (window.localStorage.getItem('roleManagement_authoritySaveData')) {
        this.authoritySaveData = window.localStorage.getItem('roleManagement_authoritySaveData')
      } 
      if (window.localStorage.getItem('roleManagement_jobList')) {
        this.jobList = JSON.parse(window.localStorage.getItem('roleManagement_jobList'))
      }
      if (window.localStorage.getItem('roleManagement_jobSaveData')) {
        this.jobSaveData = window.localStorage.getItem('roleManagement_jobSaveData')
      } 
    } else {
      if (this.isFlag && this.isFlag !== 'false') {
        this.getEditData()
      } else {
        this.getAddData()
      }
    }  
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.disabledArr.ruleFormDisabled = true
        } else {
          // 变了
          this.disabledArr.ruleFormDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    munuList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.munuSaveData) {
          // 没变
          this.disabledArr.munuDisabled = true
        } else {
          // 变了
          this.disabledArr.munuDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    authorityList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.authoritySaveData) {
          // 没变
          this.disabledArr.authorityDisabled = true
        } else {
          // 变了
          this.disabledArr.authorityDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    jobList: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.jobSaveData) {
          // 没变
          this.disabledArr.jobDisabled = true
        } else {
          // 变了
          this.disabledArr.jobDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
    disabledArr: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.disabledSaveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 角色管理编辑页面根据id获取数据
    getEditData() {
      let loading = this.$loading()
      this.$get(`/getRoleInfoById?id=${this.id}&opeateRange=1&checkGrade=2`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            // 数据赋值给变量
            this.authorityList = res.authorityListResult
            this.jobList = res.jobListResult
            this.munuList = res.munuListResult
            this.ruleForm = res.roleManagerInfo
            // 更新菜单显示数据到页面
            for (var h = 0; h < this.munuList.length; h++) {
              for (var k = 0; k < this.munuList[h].munuManagerAdminList.length; k++) {
                if (this.munuList[h].munuManagerAdminList[k].checkFlag === 1) {
                  this.$set(this.munuList[h].munuManagerAdminList[k], 'checkFlag', true) // 这里，给对象添加属性，用$set方法
                } else {
                  this.$set(this.munuList[h].munuManagerAdminList[k], 'checkFlag', false) // 这里，给对象添加属性，用$set方法
                }
              }
            }
            this.authorityList.map(item => {
              if (item.checkFlag === 1) {
                this.$set(item, 'checkFlag', true) // 这里，给对象添加属性，用$set方法。
              } else {
                this.$set(item, 'checkFlag', false) // 这里，给对象添加属性，用$set方法。
              }
              return item
            })
            this.jobList.map(item => {
              if (item.checkFlag === 1) {
                this.$set(item, 'checkFlag', true) // 这里，给对象添加属性，用$set方法。
              } else {
                this.$set(item, 'checkFlag', false) // 这里，给对象添加属性，用$set方法。
              }
              return item
            })
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.authoritySaveData = JSON.stringify(this.authorityList)
            this.jobSaveData = JSON.stringify(this.jobList)
            this.munuSaveData = JSON.stringify(this.munuList)
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 角色管理新建页面获取数据
    getAddData() {
      this.ruleForm = {
        Name: '',
        Flag: 1,
      }
      let loading = this.$loading()
      this.$get(`/getRoleInfoById?opeateRange=1&checkGrade=2`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.authorityList = res.authorityListResult
            this.jobList = res.jobListResult
            this.munuList = res.munuListResult
            // 更新菜单显示数据到页面
            for (var i = 0; i < this.munuList.length; i++) {
              for (var j = 0; j < this.munuList[i].children.length; j++) {
                this.$set(this.munuList[i].children[j], 'checkFlag', false)// 这里，给对象添加属性，用$set方法
              }
            }
            this.authorityList.map(item => {
              this.$set(item, 'checkFlag', false) // 这里，给对象添加属性，用$set方法。
              return item
            })
            this.jobList.map(item => {
              this.$set(item, 'checkFlag', false) // 这里，给对象添加属性，用$set方法。
              return item
            })
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
            this.authoritySaveData = JSON.stringify(this.authorityList)
            this.jobSaveData = JSON.stringify(this.jobList)
            this.munuSaveData = JSON.stringify(this.munuList)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回
    back() {
      this.$router.push({ name: 'roleManagementList' })
    },
    // 保存
    save(formName) {
      let params = { }
      if (this.isFlag) {
        params.Id = this.ruleForm.Id
      }
      params.Name = this.ruleForm.Name
      params.Flag = this.ruleForm.Flag
      // 为了匹配Swagger标签，content-type传递application/json格式
      // let jobId = []
      // for (var i = 0; i < this.jobList.length; i++) {
      //   if (this.jobList[i].checkFlag === true) {
      //     jobId.push(this.jobList[i].JobManagerId)
      //     params.JobManagerIdMap = jobId
      //   }
      // }
       params.JobManagerIdMap = {}
       for (var i = 0; i < this.jobList.length; i++) {
        if (this.jobList[i].checkFlag === true) {
          params.JobManagerIdMap[i] = this.jobList[i].JobManagerId           
        }
      }
      // let authorityId = []
      params.AuthorityManagerIdMap = {}
      for (var j = 0; j < this.authorityList.length; j++) {
        if (this.authorityList[j].checkFlag === true) {
          // authorityId.push(this.authorityList[j].AuthorityManagerId)
          // params.AuthorityManagerIdMap = authorityId
          params.AuthorityManagerIdMap[j] = this.authorityList[j].AuthorityManagerId
        }
      }
      let munuId = {}
      // for (var x = 0; x < this.munuList.length; x++) {
      //   munuId[x] = {}
      //   for (var y = 0; y < this.munuList[x].munuManagerAdminList.length; y++) {
      //     munuId[x][y] = -1
      //   }
      // }
      for (var h = 0; h < this.munuList.length; h++) {
        munuId[h] = {}
        for (var k = 0; k < this.munuList[h].munuManagerAdminList.length; k++) {
          if (this.munuList[h].munuManagerAdminList[k].checkFlag === true) {
              munuId[h][k] = this.munuList[h].munuManagerAdminList[k].MunuManagerInfoId
          }
        }
      }
      params.MunuManagerDataIdMap = munuId

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          this.$postJson('/AOERole', params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.$router.push({ name: 'roleManagementList' })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 清空
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.Name = ''
      this.ruleForm.Flag = 1
      for (var i = 0; i < this.jobList.length; i++) {
        this.$set(this.jobList[i], 'checkFlag', false)
      }
      for (var j = 0; j < this.authorityList.length; j++) {
        this.$set(this.authorityList[j], 'checkFlag', false)
      }
      for (var h = 0; h < this.munuList.length; h++) {
        for (var k = 0; k < this.munuList[h].munuManagerAdminList.length; k++) {
          this.$set(this.munuList[h].munuManagerAdminList[k], 'checkFlag', false)
        }
      }
    },
  } 
}
</script>

<style lang="scss">
.editRoleManagement {
  .el-checkbox,.el-checkbox-button__inner,.el-radio{
   width:160px;
  }
  .collapse {
    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }
    .el-collapse {
      border-top: 0px;
    }
    .el-collapse-item__content {
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      will-change: height;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #ebeef5;
    }
  }
  .quote {
    color: steelblue;
  }
  .classical {
    color: #419641;
  }
  .input-width{
    width: 30%;
  }
  .subtitle{
    font-size: 16px;
    font-weight:bold;
    margin-top: 10px;
    margin-left: 20px;
    margin-bottom: 10px;
  }
  .martop {
    margin-top: 20px;
    margin-left: 20px;
  }
  .el-card {
    min-height: 0px;
    margin-top: 10px;
  }
  .el-collapse {
    border-top: 0px;
  }
  .munu {
    .el-form-item__content {  
      width: 60vw !important;
    }
    .el-collapse-item__content {
      padding-left: 150px;
    }
    .el-collapse-item__header {
      padding-left: 69px;
    }
  }
  .authority{
    .el-collapse-item__header {
      border-bottom: 0px;
      padding-left: 20px;
      font-size: 16px;
      font-weight:bold;
    }
    .el-collapse-item__content {
      padding-left: 69px;
    }
  } 
  .job{
    .el-collapse-item__header {
      border-bottom: 0px;
      padding-left: 20px;
      font-size: 16px;
      font-weight:bold;
    }
    .el-collapse-item__content {
      padding-left: 69px;
    }    
  }
}
</style>